import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-widget-card-header',
  templateUrl: './widget-card-header.component.html',
  styleUrls: ['./widget-card-header.component.scss'],
})
export class WidgetCardHeaderComponent {
  @Input({ required: true }) title!: string;
  @Input() isMockPreview = false;
  @Input() isEditable = false;
  @Input() isEditMode = false;
  @Input() canDelete = true;

  private _sensorTypeLabels: string[] = [];
  visibleLabels: string[] = [];
  extraCount = 0;
  compactExtraCount = 0;

  @Input() set sensorTypeLabels(val: string[]) {
    this._sensorTypeLabels = val ?? [];
    this.visibleLabels = this._sensorTypeLabels.slice(0, 2);
    this.extraCount = Math.max(0, this._sensorTypeLabels.length - 2);
    this.compactExtraCount = Math.max(0, this._sensorTypeLabels.length - 1);
  }

  @Output() edit   = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();
}
